import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { SundryChecklistBPLReportSchemaObject } from "../SundryChecklistBPLReportSchema";
import { validateProperty } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import './printScale.css';
import moment from 'moment';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';

const screenCode = "SUNDRYCHECKLISTBPLREPORT";

export function SundryChecklistBPLReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [fields, setFields] = useState();
    const [jobs, setJobs] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const [isSearchButtonDisable, setIsSearchButtonDisable] = useState(true);

    const [dailyTaskDetailReport, setDailyTaskDetailReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fieldID: "0",
        searchDate: "",
        category: "0",
        task: "0",
        jobTypeID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        field: "0",
        searchDate: "",
        category: "0",
        task: "0",
        jobTypeID: "0"
    })

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [totalValues, setTotalValues] = useState({
        totalDay: 0,
        totalOTHours: 0
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [summarizedData, setSummarizedData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    const [reportData, setReportData] = useState([]);
    const [customSearch, setCustomSearch] = useState({
        regNumber: ''
    });
    const [hideSearch, setHideSearch] = useState(true)
    const [data1, setData1] = useState([])
    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),

        );
    }, []);

    useEffect(() => {
    }, [summarizedData, totalCount]);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [dailyTaskDetailReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [dailyTaskDetailReport.estateID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [dailyTaskDetailReport.searchDate])

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
        )
    }, [dailyTaskDetailReport.divisionID]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getJobsForDropdown(),
        );
    }, []);

    useEffect(() => {
    }, [reportData]);

    useEffect(() => {
        handleSearch1(customSearch.regNumber);
    }, [customSearch.regNumber]);

    useEffect(() => {
        if (dailyTaskDetailReport.divisionID != "0"
            && dailyTaskDetailReport.OperationEntityID != "0" && dailyTaskDetailReport.searchDate != "") {
            setIsSearchButtonDisable(false)
        }
        else {
            setIsSearchButtonDisable(true)
        }
    }, [dailyTaskDetailReport.divisionID, dailyTaskDetailReport.OperationEntityID, dailyTaskDetailReport.searchDate, dailyTaskDetailReport.jobTypeID]);

    async function handleSearch1(data2) {
        if (reportData == null || reportData.length == 0) {
            setReportData(data1)
        }
        const Default = reportData.filter(x => x.registrationNumber.toLowerCase().includes(data2.toLowerCase()) || x.firstName.toLowerCase().includes(data2.toLowerCase()))
        if (data2 == '') {
            setReportData(data1)
            return;
        }
        setReportData(Default)
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0"
        });
    }

    useEffect(() => {
        if (reportData.length != 0) {
            calculateTotal()
        }
    }, [reportData]);

    function handleEstateChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            divisionID: target.value,
            fieldID: "0"
        });
    }
    useEffect(() => {
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            divisionID: "0",
            category: "0",
            task: "0",
            searchDate: "0"
        });
    }, [dailyTaskDetailReport.estateID]);
    useEffect(() => {
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            category: "0",
            task: "0",
            searchDate: "0"
        });
    }, [dailyTaskDetailReport.divisionID]);

    function handleSearchDateChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            searchDate: target.value

        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, SundryChecklistBPLReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUNDRYCHECKLISTBPLREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                groupID: token.groupID
            });

        } else {
            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(dailyTaskDetailReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(dailyTaskDetailReport.estateID);
        setDivisions(data);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(dailyTaskDetailReport.divisionID);
        setFields(fields);
    }

    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(dailyTaskDetailReport);
    }

    async function getJobsForDropdown() {
        const result = await services.getJobsForDropdown();
        setJobs(result);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        //validateInputs(target);
        const value = target.type === "checkbox" ? target.checked : target.value;
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            [e.target.name]: value,
        });
    }

    function handleChange1(e) {
        const target = e.target;
        const value = target.value
        setCustomSearch({
            ...customSearch,
            regNumber: value
        });
    }

    async function handleSearch(e) {

        e.preventDefault();

        const summarizedResult = {};
        let total = 0;

        setIsTableHide(true);
        getSelectedDropdownValuesForReport(dailyTaskDetailReport);

        setIsTableHide(true);
        const result = await services.getSundryChecklistBPLReportData(dailyTaskDetailReport);
        result.forEach(x => {
            if (x.enityTypeID == 1) {
                x.fieldName = "Factory";
            } else {
                x.fieldName = x.fieldName;
            }
        })
        result.forEach((item) => {
            const fieldName = item.fieldName;
            const firstName = item.firstName;

            if (!summarizedResult[fieldName]) {
                summarizedResult[fieldName] = {};
            }

            if (!summarizedResult[fieldName][firstName]) {
                summarizedResult[fieldName][firstName] = 1;
            } else {
                summarizedResult[fieldName][firstName]++;
            }

            total++;
        });
        var resultOne = [];
        result.forEach(x => {

            var duplicateDate = resultOne.find(y => y.firstName === x.firstName);

            if (duplicateDate) {
                duplicateDate.registrationNumber = x.registrationNumber;
                duplicateDate.firstName = x.firstName;
                duplicateDate.taskName = x.taskName;
                duplicateDate.fieldName = x.fieldName;
                duplicateDate.taskCode = x.taskCode;
                duplicateDate.jobTypeName = x.jobTypeName;
                duplicateDate.progress = duplicateDate.progress == 100 ? duplicateDate.progress
                    : duplicateDate.progress == 50 ? duplicateDate.progress
                        : duplicateDate.progress == 1 ? x.progress
                            : x.progress == 100 ? x.progress
                                : x.progress == 50 ? x.progress : x.progress;
                duplicateDate.otHours = duplicateDate.otHours + x.otHours;
            }
            else {
                resultOne.push({
                    registrationNumber: x.registrationNumber,
                    firstName: x.firstName,
                    taskName: x.taskName,
                    fieldName: x.fieldName,
                    taskCode: x.taskCode,
                    progress: x.progress,
                    otHours: x.otHours,
                    jobTypeName: x.jobTypeName
                });
            }

        });

        const found = resultOne.filter(x => x.progress != 1)
        const foundOne = resultOne.filter(x => x.progress == 1 && x.fieldName == "Factory")
        const arr3 = found.concat(foundOne)

        result.sort((a, b) => a.taskName > b.taskName ? 1 : -1);
        const summarizedArray = Object.keys(summarizedResult).map((fieldName) => ({
            fieldName,
            count: Object.keys(summarizedResult[fieldName]).reduce(
                (acc, firstName) => acc + summarizedResult[fieldName][firstName],
                0
            ),
        }));

        setTotalCount(total);
        setSummarizedData(summarizedArray);

        setReportData(result);
        setData1(result)

        if (arr3.length > 0) {
            arr3.forEach(x => {
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setHideSearch(false)
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
            setHideSearch(true)
        }
        setIsReportButtonsEnabled();
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            field: fields[searchForm.fieldID],
            category: searchForm.category,
            task: searchForm.task,
            date: searchForm.searchDate,
            jobTypeID: searchForm.jobTypeID
        })
    }

    function calculateTotal() {
        const totalDay = reportData.reduce((accumulator, current) => {
            const progressFraction = current.progress === 100 ? 1 : current.progress === 50 ? 0.5 : 0;
            return accumulator + progressFraction;
        }, 0);

        const totalOTHours = reportData.reduce((accumulator, current) => {
            const progressFraction = current.otHours;
            return accumulator + progressFraction;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalDay: totalDay,
            totalOTHours: totalOTHours
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Sundry / Factory Checklist BPL Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyTaskDetailReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyTaskDetailReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={dailyTaskDetailReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            value={dailyTaskDetailReport.searchDate}
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="jobTypeID">Job Type</InputLabel>
                                        <Select
                                            fullWidth
                                            id="jobTypeID"
                                            name="jobTypeID"
                                            value={dailyTaskDetailReport.jobTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Job type--</MenuItem>
                                            {generateDropDownMenu(jobs)}
                                        </Select>
                                        {/* {errors["jobTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["jobTypeID"]}</FormHelperText>)} */}
                                    </div>
                                    <div className="col-md pb-1">
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        disabled={isSearchButtonDisable}
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                            {hideSearch ? '' :
                                <Box display="flex" flexDirection="row-reverse" p={2} >
                                    <TextField
                                        size="small"
                                        style={{ width: '300px' }}
                                        placeholder="Search"
                                        onChange={(e) => { handleChange1(e) }}
                                        value={customSearch.regNumber}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            }
                            {isTableHide ? null :
                                <div>
                                    {reportData.length != 0 ?
                                        <Card>
                                            <TableContainer component={Paper}>
                                                <div className="row alternative_cls bg-light  ">
                                                    <div className="card-body width1" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', marginTop: '20px' }}>
                                                    </div>
                                                    <Table aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left" colSpan={6} style={{ fontWeight: "bold", width: "250px" }}>
                                                                    Sundry / Factory Check List
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={6} style={{ fontWeight: "bold", width: "250px" }}>
                                                                    {selectedSearchValues.jobTypeID == 0 ? "All Job types" : jobs[selectedSearchValues.jobTypeID]}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="left" colSpan={3} style={{ fontWeight: "bold" }}>

                                                                </TableCell>

                                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold", width: "250px" }}>
                                                                    Initial of Field Officer
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={1} style={{ fontWeight: "bold", width: "250px" }}>

                                                                </TableCell>
                                                                <TableCell align="left" colSpan={1} style={{ fontWeight: "bold" }}>
                                                                </TableCell>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                    Date
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                                    {dailyTaskDetailReport.searchDate}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold", width: "150px" }}>
                                                                    Estate
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                                    {selectedSearchValues.estate}
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={8} style={{ fontWeight: "bold" }}>
                                                                    Name and Initial of Field Asst.
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    Division
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                                    {selectedSearchValues.division}
                                                                </TableCell>
                                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                                    No .of Workers at Muster : {reportData.length}
                                                                </TableCell>

                                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                                    Muster Distributed by :
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                                </TableCell>
                                                                <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                                    Field Officer :
                                                                </TableCell>

                                                                <TableCell align="left" colSpan={5} style={{ fontWeight: "bold" }}>
                                                                    Supervisor :
                                                                </TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    E.P.F. No.
                                                                </TableCell>
                                                                <TableCell align="center" colSpan={3} style={{ fontWeight: "bold" }}>
                                                                    Name
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    Field No.
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    Work Code
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    Work Unit
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    Work Qty
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    Day
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    OT Job Code
                                                                </TableCell>
                                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                    OT Hours
                                                                </TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {reportData.map((row, index) => (

                                                                <TableRow key={row.registrationNumber}>

                                                                    <TableCell component="th" align="center">
                                                                        {index + 1}
                                                                    </TableCell>
                                                                    <TableCell component="th" align="center" field="registrationNumber">
                                                                        {row.registrationNumber}
                                                                    </TableCell>
                                                                    <TableCell colspan={3} align="left">
                                                                        {row.firstName}
                                                                    </TableCell>
                                                                    <TableCell align="left">
                                                                        {row.fieldName}
                                                                    </TableCell>
                                                                    <TableCell align='left'>
                                                                        {row.taskName}
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {row.jobTypeName}
                                                                    </TableCell>
                                                                    <TableCell align="center"></TableCell>
                                                                    {row.progress == 100 ?
                                                                        <TableCell component="th" align="center">
                                                                            1
                                                                        </TableCell>
                                                                        : row.progress == 50 ?
                                                                            <TableCell component="th" align="center">
                                                                                0.5
                                                                            </TableCell>
                                                                            : <TableCell component="th" align="center">
                                                                                -
                                                                            </TableCell>}
                                                                    <TableCell align="center">
                                                                        {row.taskCode == null ? '-' : row.taskCode}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {row.otHours == 0 ? '-' : row.otHours}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                </TableCell>
                                                                <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">
                                                                    Total
                                                                </TableCell>

                                                                <TableCell style={{ fontWeight: "bold" }} align="right">

                                                                </TableCell>

                                                                <TableCell style={{ fontWeight: "bold" }} align="center">

                                                                </TableCell>

                                                                <TableCell style={{ fontWeight: "bold" }} align="center">

                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">

                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {totalValues.totalDay}
                                                                </TableCell>
                                                                <TableCell align="center"></TableCell>
                                                                <TableCell align="center">
                                                                    {totalValues.totalOTHours == 0 ? '' : totalValues.totalOTHours}
                                                                </TableCell>


                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell colSpan={6} style={{ fontWeight: "bold" }} align="center">
                                                                    Details of Chemicals /Fertiliser / Other Materials used
                                                                </TableCell>
                                                                <TableCell colSpan={4} style={{ fontWeight: "bold" }} align="center">
                                                                    Checked by: Supdt./Asst. Supdt/Field/Fact. Officer
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                    Time
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                    Initial
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow >
                                                                <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="center">
                                                                    Material
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                    Hect.
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                    Work Code
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                    Unit
                                                                </TableCell>
                                                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                                                    Qty. Used
                                                                </TableCell>
                                                                <TableCell colSpan={4} style={{ fontWeight: "bold" }} align="center">
                                                                    Name </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                            <TableRow >
                                                                <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="center"> </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell colSpan={4} style={{ fontWeight: "bold" }} align="center">
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                            <TableRow >
                                                                <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="center"> </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell colSpan={4} style={{ fontWeight: "bold" }} align="center">
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                            <TableRow >
                                                                <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="center"> </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell colSpan={4} style={{ fontWeight: "bold" }} align="center">
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            </TableContainer>
                                        </Card>
                                        : null}
                                    <div className="pt-2">
                                        <ReactToPrint
                                            documentTitle={"Sundry Factory Checklist Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>

                                        <CreatePdf ref={componentRef} reportData={reportData}
                                            selectedSearchValues={selectedSearchValues}
                                            totalValues={totalValues}
                                            jobs={jobs} />

                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
